import React, { useRef } from "react";
import "../ReportTable.css";
import CustomerFooter from "./CustomerFooter";
import './Customer.css';
import HeaderCustomer from "./HeaderCustomer";
import { Table } from "react-bootstrap";
import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import 'react-calendar/dist/Calendar.css';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import ApiHandler from "../../ApiHandler";
import TransferData from "../../TransferData";
import { stubString } from "lodash";
import { addDays, format } from "date-fns";
import moment from "moment";
import { Triangle } from "react-loader-spinner";
import { Button, DatePicker } from "antd";
import dayjs from "dayjs";
import LoaderTri from "../Loader/LoaderTri";
import FirmSelect from './FirmSelect';
import { getReportFirmId, getReportFirmLocalUrl, getReportFirmName } from '../../ClientSelection';
import { toast } from "react-toastify";
import { dateField } from "../../dateOnly";
import ReportExport from "../ReportExport";



const initialValues = {
    from: dayjs(),
    to: dayjs()
};
export default function Ledger() {
    const [dates, setDates] = useState(initialValues);

    const [showLedgerData, setShowLedgerData] = useState([]);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [allDatesData, setAllDatesData] = useState([])
    const [openDate, setOpenDate] = useState(false)
    const [viewdata, setViewdata] = useState(false)
    // The firm these rows belong to. Held explicitly: reading it from storage
    // at fetch time made the request depend on write ordering.
    const [firm, setFirm] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const [range, setRange] = useState([{
        startdate: new Date(),
        endDate: addDays(new Date(), ''),
        key: 'selection'
    }])





    // NOTE: wired to onClick, so the first argument may be a click event.
    function toViewData(overrideUrl) {
        setViewdata(true)
        setIsLoading(true)
        setShowLedgerData([])
        const localUrl =
            (typeof overrideUrl === "string" && overrideUrl) ||
            (firm && firm.localUrl) ||
            getReportFirmLocalUrl()
        const clientId = (firm && firm.wClientId) || getReportFirmId()
        if (!localUrl) {
            toast.error("No server configured for the selected firm")
            return
        }
        const user = JSON.parse(localStorage.getItem('user-info'))
        console.log(localUrl);

        axios({

            url: localUrl + "api/OwnApp/GetLedger",
            method: "POST",
            data: {
                // startdate: moment(selectionRange.startDate).format("YYYYMMDD"),
                // enddate: moment(selectionRange.endDate).format("YYYYMMDD"),
                code: user.code,
                // the firm from the dropdown, as its own field
                wClientId: clientId,
                startdate: dayjs(dates.from).format("YYYYMMDD"),
                enddate: dayjs(dates.to).format("YYYYMMDD"),
            },
            proxy: {
                protocol: "http",

            }
        })
            .then(((result) => {
                console.log(result);
                console.log(result.data);
                setShowLedgerData(result.data)
                setAllDatesData(result.data)
            }))
            .catch(err => {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 401) {
                    console.log(err.response);
                    //   RefreshTokenHandler();
                    //  ToastError("Token has expired Please refresh");
                }
            })
            .finally(() => {
                setIsLoading(false)
            })





    }






    const refOne = useRef(null);

    useEffect(() => {
        document.addEventListener("keydown", hideOnEscape, true)
        document.addEventListener("click", hideOnClickOutside, true)
        return () => {
            document.removeEventListener("keydown", hideOnEscape, true)
            document.removeEventListener("click", hideOnClickOutside, true)
        }
    }, []);

    const hideOnEscape = (e) => {
        //    console.log(e.key)
        if (e.key === "Escape") {
            setOpenDate(false)
        }
    }
    const hideOnClickOutside = (e) => {
        if (refOne.current && !refOne.current.contains(e.target)) {
            setOpenDate(false)
        }
    }


    const handleSelects = (date) => {

        let filtered = allDatesData.filter((product) => {

            let productDate = new Date(product["date"]);
            return (
                productDate >= date.selection.startDate &&
                productDate <= date.selection.endDate

            );
        });
        setStartDate(date.selection.startDate);
        //  setStartDate(moment(date.selection.startDate).format("DD-MM-YYYY"));
        setEndDate(date.selection.endDate);
        setShowLedgerData(filtered);
        console.log(moment(date.selection.startDate).format("DD-MM-YYYY"))
        console.log(date.selection.startDate);
        console.log(date.selection.endDate);
    };

    /* A zero or blank amount is printed as a dash: a ledger page is mostly
       empty debit or credit cells, and a column of "0.00" hides the figures
       that actually matter. Anything else is left exactly as the server
       formatted it. */
    const isEmptyAmount = (value) => {
        if (value === null || value === undefined) {
            return true;
        }

        const text = String(value).trim();

        if (!text) {
            return true;
        }

        const number = Number(text.replace(/,/g, ""));

        return !isNaN(number) && number === 0;
    };

    const amount = (value) => (isEmptyAmount(value) ? "\u2014" : value);

    const amountClass = (tone, value) =>
        ["rptAmt", tone, isEmptyAmount(value) ? "rptZero" : ""]
            .filter(Boolean)
            .join(" ");

    /* what the Excel and the PDF contain - the columns the table shows,
       through the same formatters, so the file matches the screen */
    const exportColumns = [
        { key: "date", label: TransferData.date, format: (v, row) => dateField(row, "date") },
        { key: "particulars", label: TransferData.particulars, wrap: true },
        { key: "billNo", label: TransferData.billNo },
        { key: "debit", label: TransferData.debit, align: "right", format: amount },
        { key: "credit", label: TransferData.credit, align: "right", format: amount },
        { key: "bDisAmt", label: TransferData.bDisAmt, align: "right", format: amount },
        { key: "balance", label: TransferData.balance, align: "right", format: amount },
    ];

    const reportRange = dayjs(dates.from).format("DD-MM-YYYY") + " to " +
        dayjs(dates.to).format("DD-MM-YYYY");

    const selectionRange = {
        startDate: startDate,
        endDate: endDate,
        key: "selection",
    };
    // startdate: moment(startDate).format("YYYYMMDD"),
    // endDate: moment(endDate).format("YYYYMMDD"),
    // key: "selection",



    // Record the firm and reload for it. `firm` state has not updated yet on
    // this tick, so the value is passed straight into toViewData.
    const handleFirmChange = (picked) => {
        setFirm(picked || null);
        setShowLedgerData([]);
        setAllDatesData([]);
        const next = picked && picked.localUrl;
        if (viewdata && next) {
            toViewData(next);
        }
    };

    return (
        <div className="custShell">
            <HeaderCustomer />
            <div className="custMain">

                <div className="row m-0">
                    <div className="col-lg-10 offset-lg-1  ">
                        <h5 style={{
                            marginTop: "20px",
                            fontFamily: "sans-serif",
                            // fontSize: "17px",



                        }} >Select details to view Ledger</h5 >

                        <div className="row ">
                            <div className="col-lg-3  ">
                                <FirmSelect
                                    onReady={(picked) => setFirm(picked || null)}
                                    onChange={handleFirmChange}
                                />
                            </div>
                            <div className="col-lg-3  ">
                                <DatePicker.RangePicker
                                    format={"DD-MM-YYYY"}
                                    size="middle"
                                    className=" mb-0 mr-2"
                                    value={[dates.from, dates.to]}
                                    onChange={(e) => {
                                        console.log(e);

                                        if (e) {
                                            setDates({
                                                from: e[0],
                                                to: e[1],
                                            });
                                        } else {
                                            setDates({ from: null, to: null });
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-lg-2  ">
                                <Button
                                    type="button"
                                    className="btn   btn-primary btn-sm"
                                    onClick={toViewData}
                                >View</Button>

                            </div>

                            {/* the downloads belong on this line, to the right
                                of the firm, the dates and View */}
                            <div className="col-lg-4">
                                <ReportExport
                                    className="rptExportEnd"
                                    title="View Ledger"
                                    subtitle={[getReportFirmName(), reportRange]}
                                    columns={exportColumns}
                                    rows={showLedgerData}
                                    fileName="ledger"
                                />
                            </div>
                        </div>

                        {/* <div className="enterDateInput  ">
                            <form >
                                <input
                                    required
                                    // value={`${format(range[0].startdate, 'MM-dd-yyyy')}  to  ${format(range[0].endDate, 'MM-dd-yyyy')} `}
                                    value={`${moment(selectionRange.startDate).format("DD-MM-YYYY")} to ${moment(selectionRange.endDate).format("DD-MM-YYYY")}`}
                                    readOnly
                                    onClick={() => setOpenDate(true)}
                                    style={{
                                        width: "300px",
                                        paddingLeft: '30px'

                                    }}

                                />

                                <button
                                    type="button"
                                    onClick={toViewData}

                                >View</button>
                            </form>
                        </div>

                        <div className="dateRangePicker" ref={refOne}>
                            {
                                openDate &&
                                <DateRange
                                    onChange={handleSelects}
                                    editableDateInputs={true}
                                    moveRangeOnFirstSelection={false}
                                    ranges={[selectionRange]}
                                    months={2}
                                    direction="horizontal"
                                    showMonthAndYearPickers={false}
                                    className="DaterangePicker"
                                />
                            }
                        </div> */}

                        {
                            viewdata &&
                            <div className="Ledger_table">
                                <div className="Ledger_Data p-0">

                                    <h6>Ledger</h6>
                                    {/* <Tables TransferData={TransferData} showledgerData={showledgerData} /> */}


                                    <div className="rptScroll">
                                        <Table striped className="rptTable">
                                            <thead className="threAd">
                                                <tr className="threAd_tr">
                                                    <th>{TransferData.date}</th>
                                                    <th style={{ minWidth: "150px" }}>{TransferData.particulars}</th>
                                                    <th style={{ minWidth: "200px" }}>{TransferData.billNo}</th>
                                                    {/* the body prints bill discount before the balance,
                                                        so the headings are in that order too - they were
                                                        swapped, which labelled the discount "Balance" */}
                                                    <th className="rptAmt rptDebit">{TransferData.debit}</th>
                                                    <th className="rptAmt rptCredit">{TransferData.credit}</th>
                                                    <th className="rptAmt">{TransferData.bDisAmt}</th>
                                                    <th className="rptAmt rptBalance">{TransferData.balance}</th>
                                                </tr>
                                            </thead>
                                            {

                                                showLedgerData.map((elm, index) => {
                                                    return (<tbody className="tboDY" key={index} >
                                                        <tr className={elm._Color === "Y" ? "rptRowFlag" : undefined} >
                                                            <td >{dateField(elm, 'date')}</td>
                                                            <td>{elm.particulars}</td>
                                                            <td>{elm.billNo}</td>
                                                            <td className={amountClass("rptDebit", elm.debit)}>{amount(elm.debit)}</td>
                                                            <td className={amountClass("rptCredit", elm.credit)}>{amount(elm.credit)}</td>
                                                            <td className={amountClass("", elm.bDisAmt)}>{amount(elm.bDisAmt)}</td>
                                                            <td className={amountClass("rptBalance", elm.balance)}>{amount(elm.balance)}</td>
                                                        </tr>
                                                    </tbody>)
                                                })

                                            }
                                        </Table>
                                    </div>
                                    {isLoading &&
                                        <div className="d-flex justify-content-center" style={{
                                            // marginLeft: "700px"

                                        }}>
                                            <LoaderTri />


                                        </div>
                                    }


                                </div >
                            </div >
                        }

                    </div>
                </div>

            </div>
            <CustomerFooter />
        </div>
    )
}